<div class="container-fluid">
  <div class="col-md-12" *ngIf="isLoading">
    <app-busy [message]="message"></app-busy>
  </div>
  <div class="row">
    <div style="margin-top:15px; margin-bottom:-10px;">
      <h4><span style="padding-right:10px"></span> <i class="fa fa-edit"></i>Place: <b>{{lblHeading}}</b></h4>
    </div>
  </div>
  <hr />
  A Place is any geographic location that the CBRTA or a carrier can use in describing a route. A place can be the
  start, rest, stop, landmark, destination, border-crossing, etc. of a route. Routes are made up of route-legs and each
  route-leg is from one place to another place.
  <hr />
  <div class="row" style="margin-top:20px;margin-left:0px;margin-right:0px;padding:0px;">
    <div class="col-md-12" style="margin:0px;padding:0px;">
      <form [formGroup]="form">
        <table style="margin:0px;padding:0px;width:100%">
          <tr style="margin:0px;padding:0px;">
            <td style="margin:0px;padding:0px;width:50%;vertical-align:top;">
              <div class="row" style="margin:5px auto;padding:0px;">
                <div class="col-md-6 no-sp">
                  <label class="col-sm-12 control-label">
                    <strong>Code<a class="red-asterik"> *</a></strong>
                  </label>
                  <div class="col-md-12">
                    <input type="text" name="code" formControlName="code" class="form-control" />
                    <div class="form-control-feedback text-danger text-small"
                      *ngIf="form.controls.code.invalid && form.controls.code.dirty">
                      <p *ngIf="form.controls.code.errors.required">Code is required</p>
                      <p *ngIf="form.controls.code.errors.maxlength">Code must not be more than 12 characters.</p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 no-sp">
                  <label class="col-sm-12 control-label">
                    <strong>Name<a class="red-asterik"> *</a></strong>
                  </label>
                  <div class="col-md-12">
                    <input type="text" name="name" formControlName="name" class="form-control" />
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr style="margin:0px;padding:0px;">
            <td style="margin:0px; padding:0px;width:50%; vertical-align:top;">
              <div class="row" style="margin:5px auto;padding:0px;">
                <div class="col-md-3 no-sp">
                  <label class="col-sm-12 control-label">
                    <strong>Country<a class="red-asterik"> *</a></strong>
                  </label>
                  <div class="col-md-12">
                    <select class="form-control" formControlName="country_id" id="country" #country>
                      <option value="">Select Country</option>
                      <ng-container *ngFor="let list of countryList">
                        <option [value]="list.id">{{list.desc}}</option>
                      </ng-container>
                    </select>
                  </div>
                </div>
                <div class="col-md-3 no-sp">
                  <label class="col-sm-12 control-label">
                    <strong>Province </strong>
                  </label>
                  <div class="col-md-12">
                    <select class="form-control" formControlName="province_id" id="province" #province>
                      <option value="">Select Province</option>
                      <ng-container *ngFor="let list of provinceList; let k=index;">
                        <ng-container *ngIf="country.value==list.country_id">
                          <option [value]="list.id">{{list.description}}</option>
                        </ng-container>
                      </ng-container>
                    </select>
                  </div>
                </div>
                <div class="col-md-6 no-sp">
                  <label class="col-sm-12 control-label">
                    <strong>In Town </strong>
                  </label>
                  <div class="col-md-12">
                    <select class="form-control" formControlName="parent_place_id" id="intown"
                      title="You can locate a place in another place. For example, you can say that terminus is in a town.">
                      <option value="">Select Town</option>
                      <ng-container *ngFor="let list of placeList; let k=index;">
                        <ng-container *ngIf="province.value==list.province_id">
                          <option [value]="list.id">{{list.name}}</option>
                        </ng-container>
                      </ng-container>
                    </select>
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr style="margin:0px;padding:0px;" class="">
            <td style="margin:0px;padding:0px;" colspan="2">
              <div class="row" style="margin:5px auto;padding:0px;">
                <div class="col-md-3 no-sp">
                  <label class="col-sm-12 control-label">
                    <strong>Longitude</strong>
                  </label>
                  <div class="col-md-12">
                    <input type="text" formControlName="longitude" name="longitude" class="form-control"
                      title="Decimal degrees longitude (eg. 29.986285)" />
                  </div>
                </div>
                <div class="col-md-3 no-sp">
                  <label class="col-sm-12 control-label">
                    <strong>Latitude</strong>
                  </label>
                  <div class="col-md-12">
                    <input type="text" name="latitude" formControlName="latitude" class="form-control"
                      title="Decimal degrees latitude (eg. -22.225100)" />
                  </div>
                </div>
                <div class="col-md-6 no-sp">
                  <label class="col-sm-12 control-label">
                    <strong>Coordinates</strong>
                  </label>
                  <div class="col-md-12">
                    <input type="text" name="coordinates" formControlName="coordinates" class="form-control"
                      title="DMS co-ordinates (eg. 22º13’30.36’S,29º59’10.63”E)" />
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr style="margin:0px;padding:0px;">
            <td style="margin:0px;padding:0px;">
              <div class="col-md-12">
                <div class="form-check form-check-inline col-md-12" style="margin-top:10px;padding-top:10px;">
                  <label style="width:150px;"><strong style="margin-right:5px;">Town?</strong></label>
                  <input class="form-control input-sm" formControlName="is_town" type="checkbox" id="town"
                    title="Is the place a town?" />
                </div>

                <div class="form-check form-check-inline col-md-12" style="margin-top:10px;padding-top:10px;">
                  <table style="width: 100%;">
                    <tr>
                      <td>
                        <div class="form-check form-check-inline col-md-12" style="margin-top:10px;padding-top:10px;">
                          <label style="width:150px;"><strong style="margin-right:5px;">Border
                              Crossing?</strong></label>
                          <input #isBorderCrossingRef class="form-control input-sm" formControlName="is_border_post"
                            type="checkbox" id="border" title="Is the place a border crossing?" (click)="borderPostChange(isBorderCrossingRef)" />
                        </div>
                      </td>
                      <td style="padding-top: 20px;">
                        <div *ngIf="isBorderCrossingRef.checked" class="row" style="padding:0px;">
                          <div class="col-md-4">
                            <table style="width: 110%;">
                              <tr>
                                <td align="right">
                                  <label class="control-label" style="font-size: 14px;">
                                    <strong>From country(south or east):</strong>
                                  </label>
                                </td>
                                <td style="min-width: 150px;">
                                  <select class="form-control" formControlName="border_country1_id">
                                    <option value="0">Select Country</option>
                                    <ng-container *ngFor="let list of countryList">
                                      <option [value]="list.id">{{list.desc}}</option>
                                    </ng-container>
                                  </select>
                                </td>
                              </tr>
                            </table>
                          </div>
                          <div class="col-md-4" style="padding-right: 20px;">
                            <table>
                              <tr>
                                <td align="right" style="min-width: 130px;">
                                  <label class="control-label" style="font-size: 14px;">
                                    <strong>To country(north or west):</strong>
                                  </label>
                                </td>
                                <td style="min-width: 150px;">
                                  <select class="form-control" formControlName="border_country2_id" style="margin-right: 10px;">
                                    <option value="0">Select Country</option>
                                    <ng-container *ngFor="let list of countryList">
                                      <option [value]="list.id">{{list.desc}}</option>
                                    </ng-container>
                                  </select>
                                </td>
                              </tr>
                            </table>
                          </div>
                          <div class="col-md-4" style="font-size: 13px; text-align: right; padding-top: 10px;">
                            (Please select the south or east country in the first field by convention.)
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
                <div class="form-check form-check-inline col-md-12" style="margin-top:10px;padding-top:10px;">
                  <label style="width:150px;"><strong style="margin-right:5px;">Taxi Rank?</strong></label>
                  <input class="form-control input-sm" formControlName="is_taxi_rank" type="checkbox" id="taxi-rank"
                    title="Is the place a taxi rank?" />
                </div>
                <div class="form-check form-check-inline col-md-12" style="margin-top:10px;padding-top:10px;">
                  <label style="width:150px;"><strong style="margin-right:5px;">Terminus?</strong></label>
                  <input class="form-control input-sm" formControlName="is_terminus" type="checkbox" id="terminus"
                    title="Is the place a terminus where a passenger route can start or terminate?" />
                </div>
              </div>
            </td>
          </tr>
          <tr style="margin:0px;padding:0px;">
            <td style="margin:0px;padding:0px;">
              <div class="col-md-6 no-sp">
                <label class="col-sm-12 control-label">
                  <strong>Type</strong>
                </label>
                <div class="col-md-12">
                  <input type="text" formControlName="type" name="ttype" class="form-control"
                    title="Free text field to add a type if none of the above or to supplement the above categories.?" />
                </div>
              </div>
            </td>
          </tr>
          <tr style="margin:0px;padding:0px;">
            <td style="margin:0px;padding:0px;">
              <div class="row" style="margin:5px auto;padding:0px;">
                <div class="col-md-3 no-sp">
                  <label class="col-sm-12 control-label">
                    <strong>Sort Order<a class="red-asterik"> *</a></strong>
                  </label>
                  <div class="col-md-12">
                    <select class="form-control" formControlName="sort_order" id="sortorder">
                      <option value="">Select Sort Order</option>
                      <option *ngFor="let rank of utility.sortOrderList" [ngValue]="rank" [selected]="0">{{rank}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3 no-sp">
                  <label class="col-sm-12 control-label">
                    <strong>Group Code<a class="red-asterik"> *</a></strong>
                  </label>
                  <div class="col-md-12">
                    <input type="text" formControlName="group_code" name="groupCode" class="form-control" />
                  </div>
                </div>
                <div class="col-md-4 no-sp">
                  <label class="col-sm-12 control-label">
                    <strong>Display When<a class="red-asterik"> *</a></strong>
                  </label>
                  <div class="col-md-12">
                    <select class="form-control" formControlName="display_ind" id="intown">
                      <option value="">Select Display</option>
                      <option *ngFor="let ind of utility.displayIndicators" [ngValue]="ind.key">{{ind.value}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-2 no-sp">
                  <label><strong style="margin-right:5px;">Active</strong></label>
                  <div class="form-check form-check-inline col-md-12">
                    <input class="form-control input-sm" formControlName="is_active" type="checkbox" id="active" />
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </table>

        <div class="col-md-12" style="margin-top:10px;padding-top:10px; font-size:11px;">
          <dl style="width:460px;display:inline-block;">
            <dt style="width:40px;">Created</dt>
            <dd [innerHTML]="audit.created"></dd>
            <dt style="width:46px;">Updated</dt>
            <dd [innerHTML]="audit.updated"></dd>
          </dl>
        </div>

        <!-- End -->

        <hr>
        <div class="col-md-12">
          <br>
          <button title="Save change(s)" type="submit" id="btnSave" (click)="savePlace()"
            class="btn btn-md btn-success pull-right" style="width:10%; margin-left:10px; "><i class="fa fa-save"></i>
            Save</button>
          <button title="Go Back" type="button" id="btnCancel" [routerLink]="['/countries/list/'+placeId]"
            class="btn btn-md btn-info pull-right" style="width:10%; margin-left:10px; "><i
              class="fa fa-arrow-circle-left"></i> Back</button>
        </div>
      </form>
    </div>
  </div>
</div>
<!--End Container -->